var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beta-banner"},[_c('strong',[_vm._v("内测免费")]),_vm._v(" · 视频文件保留 24 小时请及时下载 · 后期将收费 "),_c('div',{staticClass:"quota-boost-notice"},[_vm._v(_vm._s(_vm.freeQuotaNotice))]),(_vm.quotaHint)?_c('div',{staticClass:"quota-hint"},[_vm._v(_vm._s(_vm.quotaHint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }